import React from "react";
import getIcon from "../../utils/getIcon";

const TextArea = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  row = 3,
  icon
}) => {
  return (
    <div className="row mb-4 align-items-start">
      
      {/* LEFT LABEL COLUMN */}
      <div className="col-lg-2 d-flex align-items-center">
        <label className="fw-semibold">
          {label} {required && <span className="text-danger">*</span>}:
        </label>
      </div>

      {/* RIGHT INPUT COLUMN */}
      <div className="col-lg-6">
        <div className="input-group">
          <span className="input-group-text">
            {getIcon(icon)}
          </span>

        <textarea
            className="form-control"
            id={ name}
            name={name} // ✅ critical for onChange handler in parent
            cols="30"FIn
            rows={row}
            placeholder={placeholder}
            value={value ?? ""}
         onChange={(e)=>onChange(e)} 
          />
        </div>
      </div>
    </div>
  );
};

export default TextArea;
